import { useEffect } from "react";
import { useAppSelector } from "./redux";
import { cdlRepository, timeProvider } from "../AppController";
import { useDashboardStats } from "./useDashboardStats";

export const useStatsTimeout = () => {
  const {
    stats,
    statsHR,
    getStatsData,
    getStatsDataHR,
    removeStatsData,
    removeStatsDataHR,
  } = useDashboardStats({
    cdlRepository: cdlRepository,
    timeProvider,
  });
  const { statsTimeout, isPinAuthorized } = useAppSelector((state) => ({
    statsTimeout: state.dashboard.statsTimeout,
    isPinAuthorized: state.auth.isPinAuthorized,
  }));

  const hasOneHourPassed = (unixTimestamp: number) => {
    return timeProvider
      .dateLibrary()
      .isAfter(timeProvider.dateLibrary.unix(unixTimestamp).add(1, "hour"));
  };

  useEffect(() => {
    let interval = null;

    interval = setInterval(() => {
      if (isPinAuthorized && statsTimeout && hasOneHourPassed(statsTimeout)) {
        const patientIds = Object.keys({ ...stats, ...statsHR }).map((item) => {
          return Number(item);
        });

        removeStatsData(patientIds);
        removeStatsDataHR(patientIds);
        getStatsData(patientIds);
        getStatsDataHR(patientIds);
      }
    }, 5000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [statsTimeout, isPinAuthorized]);
};
